import { Component } from '@angular/core';
import { AwarenessService } from '@modules/awareness/services/awareness.service';
import { RxForDoctorFacade } from '@modules/rx-for-doctor/rx-for-doctor.facade';
import { Platforms } from '@shared/models/enums/enums';
import { RxAppSuiteBanner } from '@shared/models/rx-models/interfaces/rx-model';
import { LocalSettingsStore } from '@shared/store/localSettings/local-settings-store';
import { Observable, shareReplay } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { defaultLanguageCode } from '@shared/models/consts';
import { removeHtmlTags } from '@shared/utils/remove-html-tags';
import { BiBannerType } from '@core/services/logger/interfaces/bi.enums';
import { removeTMChar } from '@shared/utils/remove-special-char';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { Maybe } from '@/types/globals';
import { enumEquals } from '@shared/utils/enum-utils';

@Component({
	selector: 'rx-awareness-banner-design-suite',
	templateUrl: './awareness-banner-design-suite.component.html',
	styleUrls: ['./awareness-banner-design-suite.component.scss'],
	providers: [LocalSettingsStore]
})
export class AwarenessBannerDesignSuiteComponent extends BaseDestroyableComponent {
	readonly platforms = Platforms;
	companyId$: Observable<Maybe<number>> = this.rxForDoctorFacade.companyId$;
	linkToTheLearnNow$: Observable<Maybe<string>> = this.rxForDoctorFacade.linkToTheLearnNowForDesignSuite$;
	showEarlyAccessSWO$: Observable<RxAppSuiteBanner> = this.awarenessService.showEarlyAccessSWO$.pipe(
		shareReplay({ refCount: true, bufferSize: 1 })
	);

	constructor(
		private rxForDoctorFacade: RxForDoctorFacade,
		private awarenessService: AwarenessService,
		private translateService: TranslateService
	) {
		super();
	}

	get hostPlatform(): Platforms {
		return this.rxForDoctorFacade.hostPlatform;
	}

	onRegisterOrLearnNowClick(
		companyId: number,
		designSuiteBannerTranslationKey: string,
		designSuiteTitleTranslationKey: string,
		bannerType: string,
		designSuiteSubtitleTranslationKey?: string
	) {
		this.rxForDoctorFacade.updateRegisterForDesignSuite(
			companyId,
			removeHtmlTags(
				removeTMChar(
					this.getEnUSTranslatedText(
						bannerType,
						designSuiteBannerTranslationKey,
						designSuiteTitleTranslationKey,
						designSuiteSubtitleTranslationKey ?? ''
					)
				)
			),
			bannerType
		);
	}

	getEnUSTranslatedText(
		bannerType: string,
		designSuiteBannerTranslationKey: string,
		designSuiteTitleTranslationKey: string,
		designSuiteSubtitleTranslationKey: string
	): string {
		const enUSTranslationJson = this.translateService.translations[defaultLanguageCode];

		return enumEquals(bannerType, BiBannerType.BannerLearnMore)
			? enUSTranslationJson[designSuiteBannerTranslationKey][designSuiteTitleTranslationKey] +
					' ' +
					enUSTranslationJson[designSuiteBannerTranslationKey][designSuiteSubtitleTranslationKey]
			: enUSTranslationJson[designSuiteBannerTranslationKey][designSuiteTitleTranslationKey];
	}
}
